/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroupsForDropDown,
    GetAllCustomerTypes,
    GetAllFactoriesByGroupID,
    GetOutletsByCustomerTypeID,
    GetVehicleForOutboundInvoice,
    GetGTNnumberForOutboundInvoice,
    GetFDCFCCOutboundInvoiceDetails,
    UpdateAllGoodsReceivedNoteDetails,
    GetOutboundInvoiceByGTNnumber
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllCustomerTypes() {
    const response = await CommonGet('/api/OutboundInvoice/GetAllCustomerTypes', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetOutletsByCustomerTypeID(groupID, customerTypeID) {
    const response = await CommonGet('/api/OutboundInvoice/GetOutletsByCustomerTypeID', 'groupID=' + parseInt(groupID) + '&customerTypeID=' + parseInt(customerTypeID));
    return response.data;
}

async function GetVehicleForOutboundInvoice(invoiceType, factoryID, date) {
    const response = await CommonGet('/api/OutboundInvoice/GetVehicleForOutboundInvoice', 'invoiceType=' + parseInt(invoiceType) + '&factoryID='
        + parseInt(factoryID) + '&date=' + (date));
    return response.data;
}

async function GetGTNnumberForOutboundInvoice(invoiceType, factoryID, vehicleID, date) {
    const response = await CommonGet('/api/OutboundInvoice/GetGTNnumberForOutboundInvoice', 'invoiceType=' + parseInt(invoiceType) + '&factoryID=' + parseInt(factoryID)
        + '&vehicleID=' + parseInt(vehicleID) + '&date=' + (date));
    return response.data;
}

async function GetFDCFCCOutboundInvoiceDetails(model) {
    const response = await CommonPost('/api/OutboundInvoice/GetFDCFCCOutboundInvoiceDetails', null, model);
    return response.data;
}

async function UpdateAllGoodsReceivedNoteDetails(data) {
    const response = await CommonPost('/api/GoodsReceivedNote/UpdateAllGoodsReceivedNoteDetails', null, data);
    return response;
}

async function GetOutboundInvoiceByGTNnumber(gtnNumber, date) {
    const response = await CommonGet('/api/OutboundInvoice/GetOutboundInvoiceByGTNnumber', 'gtnNumber=' + (gtnNumber) + '&date=' + (date));
    return response.data;
}